//src/acl/menuTree.ts
//This is for accountangs!
import {
  DashboardIcon,
  TasksIcon,
  ManageProjectsIcon,
  DocumentsIcon,
  PercentageIcon,
  DelayIcon,
  AddSmallIcon,
  AILogo,
  EnvelopeIcon,
  PaymentsIcon,
  Magaphone2Icon,
  CalendarIcon,
  TicketIcon,
  ClientsIcon,
  AccountantsIcon,
  TimesheetIcon,
  AttachIcon,
  AccountingIcon,
  JournalIcon,
  COAIcon,
} from 'assets/icons';
import { IResourceNode } from './types';

export const MENU_TREE: IResourceNode[] = [
  {
    key: 'dashboard',
    name: 'Dashboard',
    path: '/dashboard/home',
    icon: DashboardIcon,
  },
  { key: 'tasks', name: 'Tasks', path: '/dashboard/tasks', icon: TasksIcon },
  {
    key: 'timesheets',
    name: 'Timesheets',
    path: '/dashboard/timesheets',
    icon: TimesheetIcon,
  },
  {
    key: 'accounting',
    name: 'Accounting',
    path: null,
    icon: AccountingIcon,
    children: [
      {
        key: 'journalEntries',
        name: 'Journal Entries',
        path: '/dashboard/journal_entries',
        icon: JournalIcon,
      },
      {
        key: 'accounts',
        name: 'Chart of Accounts',
        path: '/dashboard/accounts',
        icon: COAIcon,
      },
    ],
  },
  {
    key: 'tax',
    name: 'Tax',
    path: null,
    icon: ManageProjectsIcon,
    children: [
      {
        key: 'taxReturns',
        name: 'Returns',
        path: '/dashboard/taxReturns',
        icon: ManageProjectsIcon,
      },
      {
        key: 'taxEstimates',
        name: 'Estimates',
        path: '/dashboard/taxEstimates',
        icon: PercentageIcon,
      },
      {
        key: 'taxExtensions',
        name: 'Extensions',
        path: '/dashboard/taxExtensions',
        icon: DelayIcon,
      },
      {
        key: 'taxFinCEN',
        name: 'FinCEN',
        path: '/dashboard/fincenReports',
        icon: DocumentsIcon,
      },
    ],
  },

  {
    key: 'documents',
    name: 'Documents',
    path: '/dashboard/documents',
    icon: DocumentsIcon,
  },
  {
    key: 'services',
    name: 'Services',
    path: '/dashboard/services',
    icon: AddSmallIcon,
  },
  {
    key: 'controlServices',
    name: 'Control Services',
    path: '/dashboard/control-services',
    icon: ManageProjectsIcon,
  },
  { key: 'aiMito', name: 'AI Mito', path: '/dashboard/ai-mito', icon: AILogo },
  {
    key: 'messages',
    name: 'Messages',
    path: '/dashboard/messages',
    icon: EnvelopeIcon,
  },
  {
    key: 'privacy',
    name: 'Privacy Policy',
    path: '/dashboard/privacy-policy',
    icon: DocumentsIcon,
  },

  // finance / admin extras
  {
    key: 'promoCodes',
    name: 'Promo Codes',
    path: '/dashboard/promocodes',
    icon: PaymentsIcon,
  },
  {
    key: 'announcements',
    name: 'Announcements',
    path: '/dashboard/announcements',
    icon: Magaphone2Icon,
  },
  {
    key: 'upcomingDates',
    name: 'Upcoming Dates',
    path: '/dashboard/upcomingDates',
    icon: CalendarIcon,
  },
  {
    key: 'tickets',
    name: 'Tickets',
    path: '/dashboard/tickets',
    icon: TicketIcon,
  },
  {
    key: 'bundles',
    name: 'Bundles',
    path: '/dashboard/billing',
    icon: PaymentsIcon,
  },

  {
    key: 'clients',
    name: 'Clients',
    path: '/dashboard/clients',
    icon: ClientsIcon,
  },
  {
    key: 'accountants',
    name: 'Accountants',
    path: '/dashboard/viewAccountants',
    icon: AccountantsIcon,
  },
];
